import Jsvcn from "jsvcn";
import {
    FOUNDATION_HOST,
    FOUNDATION_HOST_STAGING,
    BLOCKCHAIN_HOST,
    BLOCKCHAIN_HOST_STAGING,
    BLOCKCHAIN_ASSET_ADDRESS,
    BLOCKCHAIN_ASSET_ADDRESS_STAGING,
    BLOCKCHAIN_ORG_ADDRESS,
    BLOCKCHAIN_ORG_ADDRESS_STAGING
} from "./config";

const verificationDefault = {
    state: "waiting",
    size: null,
    name: null,
    progress: 0,
    hash: null,
    organization: null,
    signer: null,
    type: null,
    status: null
};

const store = {
    state: {
        organization: null,
        verification: Object.assign({}, verificationDefault),
        assetInfo: {},
        signer: null,
        assetInfoWindow: false,
        checksums: {
            sha1: undefined,
            sha256: undefined,
            md5: undefined
        }
    },
    getters: {
        verificationState: state => {
            return state.verification.state;
        },
        verification: state => {
            return state.verification;
        },
        assetInfoWindow: state => {
            return state.assetInfoWindow;
        },
        checksums: state => {
            return state.checksums;
        },
        assetInfo: state => {
            return state.assetInfo;
        },
        organization: state => {
            return state.organization;
        },
        signer: state => {
            return state.signer;
        }
    },
    mutations: {
        reset(state) {
            state.assetInfo = {};
            state.assetInfoWindow = false;
            state.verification = Object.assign({}, verificationDefault);
        },
        verificationSuccess(state, { fileHash, fileName, type }) {
            state.verification.state = "success";
            state.verification.name = fileName;
            state.verification.hash = fileHash;
            state.verification.type = type;
        },
        verificationFailed(state, { fileHash, fileName, type, status }) {
            state.verification.state = "failed";
            state.verification.name = fileName;
            state.verification.status = status;
            state.verification.hash = fileHash;
            state.verification.type = type;
        },
        verificationError(state) {
            state.verification.state = "error";
        },
        verificationProgress(state, { fileName, progress }) {
            state.verification.state = "inprogress";
            state.verification.name = fileName;
            state.verification.progress = progress;
        },
        checksums(state, checksums) {
            state.checksums = checksums;
        },
        assetInfo(state, details) {
            state.assetInfo = details;
        },
        assetInfoWindow(state) {
            state.assetInfoWindow = !state.assetInfoWindow;
        },
        UPDATE_ORG(state, organization) {
            if (organization) state.organization = organization;
        },
        RESET_ORG(state) {
            state.organization = null;
        },
        UPDATE_SIGNER(state, signer) {
            state.signer = signer;
        },
        RESET_SIGNER(state) {
            state.signer = null;
        }
    },
    actions: {
        reset({ commit }) {
            commit("reset");
        },
        async organization({ commit }, organizationName) {
            const foundationUrl =
                process.env.NODE_ENV == "production"
                    ? FOUNDATION_HOST
                    : FOUNDATION_HOST_STAGING;

            const endpoint =
                foundationUrl + "/organisation/" + organizationName;

            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (response.status !== 404) {
                const org = await response.json();
                commit("UPDATE_ORG", org);
            }
        },
        async signer({ commit }, signerId) {
            const signer = { id: signerId, name: "" };

            commit("UPDATE_SIGNER", signer);
            //TODO once we have signer endpoint we could query signer details
        },
        resetOrganization({ commit }) {
            commit("RESET_ORG");
        },
        resetSigner({ commit }) {
            commit("RESET_SIGNER");
        },
        async verify({ commit, state }, file) {
            const { name } = file;
            const type = typeof file === "string" ? "hash" : "file";
            const blockchainUrl =
                process.env.NODE_ENV == "production"
                    ? BLOCKCHAIN_HOST
                    : BLOCKCHAIN_HOST_STAGING;
            const assetUrl =
                process.env.NODE_ENV == "production"
                    ? FOUNDATION_HOST
                    : FOUNDATION_HOST_STAGING;

            const blockchainAssetAddress =
                process.env.NODE_ENV == "production"
                    ? BLOCKCHAIN_ASSET_ADDRESS
                    : BLOCKCHAIN_ASSET_ADDRESS_STAGING;
            const blockchainOrganizationAddress =
                process.env.NODE_ENV == "production"
                    ? BLOCKCHAIN_ORG_ADDRESS
                    : BLOCKCHAIN_ORG_ADDRESS_STAGING;
            const jsvcn = new Jsvcn({
                blockchainUrl,
                assetUrl,
                mode: "blockchain",
                blockchainAssetAddress,
                blockchainOrganizationAddress,
                checksums: ["sha256", "sha1", "md5", "sha512"]
            });

            let against = null;
            if (state.organization) against = state.organization.name;
            if (state.signer) against = [state.signer.id];

            const asset = await jsvcn.verify(
                file,
                progress =>
                    commit("verificationProgress", {
                        progress,
                        fileName: name
                    }),
                against
            );
            const { verification, checksums } = asset;
            const isValid = verification.status === "TRUSTED";
            if (isValid) {
                commit("verificationSuccess", {
                    fileHash: asset.hash,
                    fileName: name,
                    type
                });
                commit("assetInfo", asset);
                commit("checksums", checksums);
            } else {
                commit("verificationFailed", {
                    fileHash: asset.hash,
                    fileName: name,
                    status: verification.status,
                    type
                });
                commit("checksums", checksums);
            }
        }
    }
};
export default store;
